export default __webpack_public_path__ + "static/profile_no-c3f945216dc12c9498dcd01a160fd2d3.png";